import { Box, withStyles } from '@material-ui/core';

export const WrapperBox = withStyles(() => ({
  root: {
    width: '100%',
    maxWidth: 400,
  },
}))(Box);
